/** @jsxImportSource @emotion/react */

import { ReactNode } from 'react';
import {containerStyles, usePositionAbsolute, usePositionFixed} from './utils-sticky-bottom-cta.module.style';

/* eslint-disable-next-line */
export interface UtilsStickyBottomCtaProps {
  children: ReactNode,
  className?: string,
  usePositionAbsolute?: boolean,
  usePositionFixed?: boolean
}

export function UtilsStickyBottomCta(props: UtilsStickyBottomCtaProps) {
  return (
    <div css={[
        containerStyles, 
        props.usePositionAbsolute ? usePositionAbsolute : null,
        props.usePositionFixed ? usePositionFixed : null
      ]} className={props.className}>
      {props.children}
    </div>
  );
}
